import { useEffect, useState } from 'react';
import { Button } from '../../../components-reactjs/Button';
import { Header, HeaderTitle } from '../styles';

import { ModalCadastroUsuario } from './components/CadastrarUsuarioModal';
import { EditarUsuarioModal } from './components/EditarUsuarioModal';
import { UsuariosFiltros } from './components/UsuariosFiltros';
import { UsuariosTable } from './components/UsuariosTable';
import {
    changeAuthUserStatus,
    findPedidosAbertos,
    getAuthUsers,
    saveAuthUser,
    updateAuthUser
} from './services';
import { notifyError, notifySuccess } from './utils';

import { CircularProgressIndicator } from '../../../components-reactjs/CircularProgressIndicator';
import ButtonLoading from '../../../react-component/buttonLoading';
import Modal from '../../../react-component/modal';

import {
    ButtonContainer,
    ButtonHeaderContainer,
    Container,
    Footer,
    PaginationContainer,
    StyledPagination,
    Text,
    UsuariosContainer
} from './styles';

let searchTimer;
const emailRegex =
    /^(?!.*\.\.)(?!\.)(?!.*\.$)[A-Za-z][A-Za-z0-9_%+-]+(?:\.[A-Za-z0-9_%+-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?\.)+[A-Za-z]{2,}$/;

const Usuarios = () => {
    const [email, setEmail] = useState('');

    const [editedEmail, setEditedEmail] = useState('');
    const [editedPhone, setEditedPhone] = useState('');
    const [editedCpfCnpj, setEditedCpfCnpj] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isInitialLoading, setIsInitialLoading] = useState(true);
    const [errorMessage, setErrorMessage] = useState('');
    const [editErrorMessage, setEditErrorMessage] = useState('');
    const [editPhoneErrorMessage, setEditPhoneErrorMessage] = useState('');
    const [editCpfCnpjErrorMessage, setEditCpfCnpjErrorMessage] = useState('');
    const [modalCadastroVisible, setModalCadastroVisible] = useState(false);
    const [modalEdicaoVisible, setModalEdicaoVisible] = useState(false);
    const [usuarioEdicao, setUsuarioEdicao] = useState(null);
    const [modalButtons, setModalButtons] = useState({
        isVisible: false,
        enableTopClose: false,
        title: '',
        message: '',
        confirmText: '',
        cancelText: '',
        handleConfirm: () => {},
        handleCancel: () => {}
    });

    const [tableData, setTableData] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [total, setTotal] = useState(0);
    const [search, setSearch] = useState('');
    const [limit, setLimit] = useState(10);
    const [statusFilter, setStatusFilter] = useState('Todos');
    const [page, setPage] = useState(1);

    const tableLimits = [10, 20, 30];
    const tableStatusFilter = ['Todos', 'Ativos', 'Inativos'];

    const getTableData = () => {
        const status = statusFilter.toLowerCase();
        setIsLoading(true);

        getAuthUsers({
            search,
            page,
            limit,
            status
        })
            .then(({ data }) => {
                setTableData(data.usuarios);
                setTotal(data.total);
            })
            .catch(() => {
                notifyError('Não foi possível buscar os usuários');
            })
            .finally(() => {
                setIsLoading(false);
                setIsInitialLoading(false);
            });
    };

    const saveUser = () => {
        const formatedEmail = email.toLowerCase().trim();

        setIsLoading(true);
        if (!formatedEmail) {
            setErrorMessage('Campo obrigatório');
            setIsLoading(false);
            return;
        } else if (!emailRegex.test(formatedEmail)) {
            setErrorMessage('Email inválido');
            setIsLoading(false);
            return;
        }

        setErrorMessage('');
        saveAuthUser({
            login: formatedEmail
        })
            .then(() => {
                notifySuccess('Usuário cadastrado com sucesso');
                setEmail('');
                setIsLoading(false);
                setModalCadastroVisible(false);
                getTableData();
            })
            .catch((res) => {
                const msg =
                    (res.response &&
                        res.response.data &&
                        res.response.data.errorMessage) ||
                    'Não foi possível cadastrar o usuário';
                notifyError(msg);
                setIsLoading(false);
            });
    };

    const updateUserData = () => {
        const formatedEmail = editedEmail.toLowerCase().trim();

        if (!usuarioEdicao || !usuarioEdicao.idUsuario) {
            notifyError('Usuário inválido para edição');
            return;
        }

        if (!formatedEmail) {
            setEditErrorMessage('Campo obrigatório');
            return;
        }

        if (!emailRegex.test(formatedEmail)) {
            setEditErrorMessage('Email inválido');
            return;
        }

        const currentEmail = (usuarioEdicao.dsLogin || '').toLowerCase().trim();
        const shouldUpdateEmail = formatedEmail !== currentEmail;

        setEditErrorMessage('');

        if (!shouldUpdateEmail) {
            setModalEdicaoVisible(false);
            setUsuarioEdicao(null);
            return;
        }

        setIsLoading(true);

        updateAuthUser({
            idUsuario: usuarioEdicao.idUsuario,
            login: formatedEmail
        })
            .then(() => {
                notifySuccess('Dados do usuário atualizados com sucesso');
                setEditedEmail('');
                setEditedCpfCnpj('');
                setUsuarioEdicao(null);
                setModalEdicaoVisible(false);
                getTableData();
            })
            .catch((res) => {
                const msg =
                    (res.response &&
                        res.response.data &&
                        res.response.data.errorMessage) ||
                    'Não foi possível atualizar os dados do usuário';
                notifyError(msg);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const updateUserStatus = (userList = []) => {
        setIsLoading(true);
        const [firstUser] = userList;
        const active = !firstUser.fgAtivo;

        changeAuthUserStatus({
            userList,
            active
        })
            .then(() => {
                notifySuccess('Registros alterados com sucesso');
                setIsLoading(false);
                setSelectedUsers([]);
                setTableData([]);
                getTableData();
            })
            .catch(() => {
                notifyError(
                    'Não foi possível alterar os registros selecionados'
                );
                setIsLoading(false);
            });
    };

    const handleUserCheckbox = (user) => {
        const userIndex = selectedUsers.findIndex(
            (u) => u.idUsuario === user.idUsuario
        );
        const newSelectedUsers = Object.assign([...selectedUsers]);
        if (userIndex < 0) {
            newSelectedUsers.push(user);
        } else {
            newSelectedUsers.splice(userIndex, 1);
        }
        setSelectedUsers(newSelectedUsers);
    };

    const validateRemainingUsers = (users) => {
        const remainingUsers = selectedUsers.filter((user) => {
            let isRemaining = true;
            users.forEach((userToRemove) => {
                if (userToRemove.idUsuario === user.idUsuario) {
                    isRemaining = false;
                }
            });
            return isRemaining;
        });

        if (!remainingUsers.length) return;

        setModalButtons({
            isVisible: true,
            title: 'Atenção',
            message: `Deseja inativar os demais registros selecionados?`,
            confirmText: 'Sim',
            cancelText: 'Não',
            handleCancel: () => {
                setModalButtons({ isVisible: false });
            },
            handleConfirm: () => {
                updateUserStatus(remainingUsers);
                setModalButtons({ isVisible: false });
            }
        });
    };

    const renderStatusModal = (active) => {
        setModalButtons({
            isVisible: true,
            enableTopClose: true,
            title: active ? 'Ativar usuário(s)' : 'Desativar usuário(s)',
            message: 'Os registros selecionados terão seu status alterado.',
            confirmText: active ? 'Ativar' : 'Desativar',
            handleConfirm: () => {
                updateUserStatus(selectedUsers);
                setModalButtons({ isVisible: false });
            }
        });
    };

    const validateUsersToChangeStatus = () => {
        setIsLoading(true);
        const [firstUser] = selectedUsers;
        const active = !firstUser.fgAtivo;
        if (active) {
            setIsLoading(false);
            renderStatusModal(active);
            return;
        }

        findPedidosAbertos({
            userList: selectedUsers
        })
            .then((res) => {
                const { usuarios } = res.data;
                if (!usuarios || !usuarios.length) {
                    setIsLoading(false);
                    renderStatusModal(active);
                    return;
                }

                const stringUsuarios = usuarios
                    .map((usuario) => usuario.dsLogin)
                    .join('\n');

                setIsLoading(false);
                setModalButtons({
                    isVisible: true,
                    title: 'Atenção',
                    message: `Os seguintes usuários possuem pedidos em aberto:\n\n${stringUsuarios}\n\nDeseja inativa-los mesmo assim?`,
                    confirmText: 'Sim',
                    cancelText: 'Não',
                    handleCancel: () => {
                        setIsLoading(false);
                        setModalButtons({ isVisible: false });
                        validateRemainingUsers(usuarios);
                    },
                    handleConfirm: () => {
                        setIsLoading(false);
                        setModalButtons({ isVisible: false });
                        updateUserStatus(selectedUsers);
                    }
                });
            })
            .catch((e) => {
                console.log(e);
                notifyError('Não foi possível validar os usuários');
                setIsLoading(false);
            });
    };

    const checkDisableActivateButton = () => {
        if (!selectedUsers.length) return true;
        let disable = false;
        const userStatus = selectedUsers[0].fgAtivo;
        selectedUsers.forEach((user) => {
            if (user.fgAtivo !== userStatus) disable = true;
        });
        return disable;
    };

    const checkBgcolorActivateButton = () => {
        return selectedUsers[0].fgAtivo ? '#ff4112' : '#08cc71';
    };

    const checkTextActivateButton = () => {
        if (selectedUsers.length) {
            return selectedUsers[0].fgAtivo ? 'Desativar' : 'Ativar';
        } else {
            return 'Ativar';
        }
    };

    const verifyCheckboxDefaultValue = (currentUser) => {
        const result = selectedUsers.find(
            (selectedUser) => selectedUser.idUsuario === currentUser.idUsuario
        );
        return !!result;
    };

    const handleStartEditUser = (user) => {
        setUsuarioEdicao(user);
        setEditedEmail(user.dsLogin || '');
        setEditedPhone(user.dsTelefone || '');
        setEditedCpfCnpj(user.dsCpfCnpj || '');
        setEditErrorMessage('');
        setEditPhoneErrorMessage('');
        setEditCpfCnpjErrorMessage('');
        setModalEdicaoVisible(true);
    };

    const handleCloseEditModal = () => {
        setModalEdicaoVisible(false);
        setEditedEmail('');
        setEditedPhone('');
        setEditedCpfCnpj('');
        setEditErrorMessage('');
        setEditPhoneErrorMessage('');
        setEditCpfCnpjErrorMessage('');
        setUsuarioEdicao(null);
    };

    useEffect(() => {
        getTableData();
    }, [page, limit, statusFilter]);

    useEffect(() => {
        if (search.length) {
            clearTimeout(searchTimer);
            searchTimer = setTimeout(() => {
                getTableData();
            }, 300);
        } else if (!search.length) {
            getTableData();
        }
    }, [search]);

    if (isInitialLoading) {
        return <CircularProgressIndicator />;
    }

    return (
        <UsuariosContainer>
            <Header>
                <HeaderTitle>Usuários</HeaderTitle>

                <ButtonHeaderContainer>
                    <ButtonLoading
                        label={'Cadastrar'}
                        onPress={() => {
                            setModalCadastroVisible(true);
                        }}
                        isLoading={false}
                        disabled={false}
                        style={{ marginTop: 0 }}
                    />
                </ButtonHeaderContainer>
            </Header>

            {modalCadastroVisible && (
                <ModalCadastroUsuario
                    saveUser={saveUser}
                    setModalCadastroVisible={setModalCadastroVisible}
                    setEmail={setEmail}
                    email={email}
                    isLoading={isLoading}
                    errorMessage={errorMessage}
                />
            )}

            <EditarUsuarioModal
                visible={modalEdicaoVisible}
                onSave={updateUserData}
                onClose={handleCloseEditModal}
                editedEmail={editedEmail}
                setEditedEmail={setEditedEmail}
                editedPhone={editedPhone}
                setEditedPhone={setEditedPhone}
                editedCpfCnpj={editedCpfCnpj}
                setEditedCpfCnpj={setEditedCpfCnpj}
                editErrorMessage={editErrorMessage}
                editPhoneErrorMessage={editPhoneErrorMessage}
                editCpfCnpjErrorMessage={editCpfCnpjErrorMessage}
                isLoading={isLoading}
            />

            {modalButtons.isVisible && (
                <Modal
                    size={'textModal'}
                    title={modalButtons.title}
                    saveText={modalButtons.confirmText}
                    cancelText={modalButtons.cancelText}
                    onSave={modalButtons.handleConfirm}
                    onClose={modalButtons.handleCancel}
                    enabledClose={!!modalButtons.cancelText}
                    enableTopClose={modalButtons.enableTopClose}
                    isSaveButtonLoading={isLoading}
                >
                    <Text>{modalButtons.message}</Text>
                </Modal>
            )}

            <Container>
                <UsuariosFiltros
                    search={search}
                    setSearch={setSearch}
                    limit={limit}
                    setLimit={setLimit}
                    statusFilter={statusFilter}
                    setStatusFilter={setStatusFilter}
                    tableLimits={tableLimits}
                    tableStatusFilter={tableStatusFilter}
                />

                <UsuariosTable
                    tableData={tableData}
                    onEditUser={handleStartEditUser}
                    handleUserCheckbox={handleUserCheckbox}
                    verifyCheckboxDefaultValue={verifyCheckboxDefaultValue}
                />

                <Footer>
                    <ButtonContainer>
                        <Button
                            title={checkTextActivateButton()}
                            onClick={validateUsersToChangeStatus}
                            disabled={checkDisableActivateButton()}
                            style={{
                                fontSize: '1.5rem',
                                fontFamile: 'NunitoSans-Regular',
                                maxHeight: 30,
                                backgroundColor: checkDisableActivateButton()
                                    ? 'grey'
                                    : checkBgcolorActivateButton(),
                                opacity: checkDisableActivateButton()
                                    ? '0.5'
                                    : '1'
                            }}
                            isLoading={isLoading}
                        />
                    </ButtonContainer>

                    <PaginationContainer>
                        <StyledPagination
                            count={Math.ceil(total / limit)}
                            color="primary"
                            size="medium"
                            onChange={(e, page) => {
                                setPage(page);
                            }}
                        />
                    </PaginationContainer>
                </Footer>
            </Container>
        </UsuariosContainer>
    );
};

export { Usuarios };
